import { render, staticRenderFns } from "./TeaserImage.vue?vue&type=template&id=b7b8e47a&"
import script from "./TeaserImage.vue?vue&type=script&lang=js&"
export * from "./TeaserImage.vue?vue&type=script&lang=js&"
import style0 from "./TeaserImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports